<script setup>
  import ComponentTransferImportDialog from "@components/Dialogs/TransferImportDialog.vue";
  import ComponentDashboard from "@pages/Dashboard/Components/Dashboard.vue";

  defineOptions({
    name: "PagesDeeplinkTransfer",
  });

  defineProps({
    transfer: {
      type: Object,
      required: true,
    },
  });
</script>

<template>
  <ComponentDashboard v-bind="$page.props" />
  <ComponentTransferImportDialog :transfer="transfer" :test-id="getTestId()" />
</template>
